import ExitModal from '../Modal/exitForm.component';
import logo from '../../images/cigna-healthcare-logo.svg';
import ITokenService from '../../interfaces/ITokenService';
import './header.component.css';

type AppProps = {
  tokenService: ITokenService,
  sessionType: string,
  skipSavePriorAuthorization: boolean
};

const Header = (props: AppProps) => (
  <header className="App-header" data-testid="header">
    <div className="header-alignment">
      <img alt="Logo" title="Health-Plan-Logo" src={logo} />
      <div className="app-header-buttons">
        <ExitModal
          tokenService={props.tokenService}
          sessionType={props.sessionType}
          skipSavePriorAuthorization={props.skipSavePriorAuthorization}
        />
      </div>
    </div>
  </header>
);
export default Header;
